import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface HotRankingProps {
  movies: Movie[];
}

export default function HotRanking({ movies }: HotRankingProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
              <i className="ri-fire-line text-primary-500 text-lg"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              热门排行
            </h2>
          </div>
          <Link
            to="/category/hot"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-5">
          {movies.slice(0, 10).map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex items-start gap-3 p-3 rounded-lg bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold ${
                index < 3
                  ? 'bg-accent-500 text-white'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {movie.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <div className="flex items-center gap-0.5">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                    </div>
                    <span className="text-xs text-accent-500 font-medium">{movie.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{movie.category}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}